import React, { Component } from 'react';
import Helmet from 'react-helmet';
import config from '../../config';
import '../../theme/styles/styles.css';
import styles from './App.less';
import { Route, Redirect, Router } from 'react-router-dom';
import { createBrowserHistory } from "history";

import { isLoaded as isAuthLoaded, load as loadAuth } from '../../redux/modules/auth';

import Login from '../../containers/Login';
import Home from '../../containers/Home';
import ModalComponent from '../../containers/Modal';
import SessionExpiredComponent from '../SessionExpired';
import NotFound from '../NotFound';

const customHistory = createBrowserHistory();

const App = (store) => {

  const requireLogin = (nextState, replace, cb) => {
    function checkAuth() {
      const user = localStorage.getItem('user');
      if (!user) {
        replace('/login');
      }
      cb();
    }
    if (!isAuthLoaded(store.getState())) {
      store.dispatch(loadAuth());
      checkAuth();
    } else {
      checkAuth();
    }
  };

  return (
    <div className={styles.app}>
      <Helmet {...config.app.head} />
      <div className={styles.appContent}>
        <Router history={customHistory}>
          <Route exact path="/login" component={Login} />
          <Route exact path="/" component={Login} />
          <Route onEnter={requireLogin}>
            <Route exact path="/home" component={Home} />
          </Route>
          {/* <Redirect from="logout" to="login" /> */}
          <Route path="/session_expired" component={ModalComponent} />
          <Route path="/backbutton" component={SessionExpiredComponent} />
          { /* Catch all route */}
          <Route path="/notFound" component={NotFound} status={404} />
        </Router>
      </div>
    </div>
  )
}

export default App;
